import React from 'react';
import Header from './Header';

const UserInfo = ({ userInfo, errors, onChange, onBack, onSubmit }) => {
  return (

    <div className="">
        <h4 className="fw-bold text-center">Your Information</h4>
        <p className="text-muted mb-4 text-center">
        Please provide your details before starting the assessment.
        </p>

        <div className="mb-3">
        <label className="fw-semibold mb-1">Full Name</label>
        <input
            type="text"
            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
            value={userInfo.name}
            onChange={(e) => onChange("name", e.target.value)}
            placeholder="Enter your full name"
        />
        {errors.name && (
            <div className="text-danger mt-1">{errors.name}</div>
        )}
        </div>

        <div className="mb-3">
        <label className="fw-semibold mb-1">Email Address</label>
        <input
            type="email"
            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
            value={userInfo.email}
            onChange={(e) => onChange("email", e.target.value)}
            placeholder="Enter your email address"
        />
        {errors.email && (
            <div className="text-danger mt-1">{errors.email}</div>
        )}
        </div>

        <div className="mb-3">
        <label className="fw-semibold mb-1">Phone Number</label>
        <input
            type="tel"
            className="form-control"
            value={userInfo.phone}
            onChange={(e) => onChange("phone", e.target.value)}
            placeholder="Enter your phone number"
        />
        </div>

        <div className="mb-4">
            <label className="fw-semibold mb-1">Date of Birth</label>
            <input
                type="date"
                className={`form-control ${errors.dob ? 'is-invalid' : ''}`}
                value={userInfo.dob}
                onChange={(e) => onChange("dob", e.target.value)}
            />
            {errors.dob && (
                <div className="text-danger mt-1">{errors.dob}</div>
            )}
        </div>
        <div className='mb-4'>
            <label className="fw-semibold mb-1">Address</label>
            <input
                type="text"
                className={`form-control ${errors.address1 ? 'is-invalid' : ''}`}
                value={userInfo.address1}
                onChange={(e) => onChange("address1", e.target.value)}
                placeholder="Enter your address"
            />
        </div>
        <div className='mb-4'>
            <label className="fw-semibold mb-1">Postcode</label>
            <input
                type="text"
                className={`form-control ${errors.zip ? 'is-invalid' : ''}`}
                value={userInfo.zip}
                onChange={(e) => onChange("zip", e.target.value)}
                placeholder="Enter your postcode"
            />
        </div>

        <div className="d-flex justify-content-between mt-4 mb-4 gap-10">
        <button
            type="button"
            className="btncust"
            onClick={onBack}
        >
            Back
        </button>
        <button
            type="button"
            className="btncust activebg"
            onClick={onSubmit}
        >
            Continue
        </button>
        </div>

    </div>

  );
};

export default UserInfo;
